var i;
i = 0;
(function ($, jQuery) {
    $(document).ready(function () {

        // $(".eu-cookie-compliance-category").each(function(){
        //     if($(this).find('input[type="checkbox"]').first().attr("checked")){
        //         $(this).addClass('image-checkbox-checked');
        //     }else{
        //         $(this).removeClass('image-checkbox-checked');
        //     }
        // });

        // // sync the input state
        // $(".eu-cookie-compliance-category").slice(1).on("click", function(e){
        //     $(this).toggleClass('image-checkbox-checked');
        //     var $checkbox = $(this).find('input[type="checkbox"]');
        //     $checkbox.prop("checked",!$checkbox.prop("checked"));
        //     e.preventDefault();
        // });

        //Cookies code

        var windowWidth = $(window).width();

        $(".cookie-config-button").on('click', function () {
            $(".eu-cookie-compliance-save-preferences-button").addClass("cookies-active");
            $(".pop-up-cookies").addClass("cookies-active");
            $("#eu-cookie-compliance-categories").addClass("cookies-active");
            $(".eu-cookie-compliance-category").addClass("cookies-active");
            $(".background-cover").addClass("cookies-active");
            $("body").addClass("body-lock");
            $(".eu-cookie-compliance-buttons").addClass("cookies-active");
            $(".eu-cookie-compliance-categories-buttons").addClass("cookies-active");

            if (windowWidth > 909) {
            $('.agree-button').animate({
                top: 282//moves to position
            }, 0);
            }
        });

        $(".eu-cookie-compliance-category>div").on('click', function (e) {
            if (e.target !== this) {
                return;
            }


            if ($(this).parent().hasClass("eu-cookie-compliance-category-expanded")) {
                var height = $(this).parent().height();
                // var windowWidth = $(window).width();
                if (windowWidth > 909) {
                    $('.pop-up-cookies').animate({
                        height: 300, //moves up
                        "margin-top": 0
                    });
                }
                $('.agree-button').animate({
                    top: "-=" + height //moves up
                });
                
                

                // if (windowWidth < 910) {
                    $('.eu-cookie-compliance-save-preferences-button').animate({
                        top: "-=" + height //moves up
                    });
                // }
                $(this).parent().removeClass("eu-cookie-compliance-category-expanded")


            } else {
                if ($(".eu-cookie-compliance-category-expanded").length > 0) {
                    var height = $(".eu-cookie-compliance-category-expanded").height();
                    // console.log(height);

                    $(".eu-cookie-compliance-category").removeClass("eu-cookie-compliance-category-expanded");
                    $(this).parent().addClass("eu-cookie-compliance-category-expanded");
                    var height2 = $(this).parent().height();
                    // console.log(height2);

                    var height3 = height - height2;
                    // console.log(height3);
                    var heightdiff = height2/2;
                    // console.log(heightdiff);
                    // var windowWidth = $(window).width();
                    if (windowWidth > 909) {
                        $('.pop-up-cookies').animate({
                            height: "-=" + height3,
                            "margin-top": heightdiff //increases height or decreases depending on values
                        });
                    }

                    $('.agree-button').animate({
                        top: "-=" + height3 //moves down or up depending on values of height3
                    });

                    // if (windowWidth < 910) {
                        $('.eu-cookie-compliance-save-preferences-button').animate({
                            top: "-=" + height3 //moves down or up depending on values of height3
                        });
                    // }
                    
                } else {
                    $(this).parent().addClass("eu-cookie-compliance-category-expanded");
                    var height = $(".eu-cookie-compliance-category-expanded").height();
                    var heightdiff = height/2;
                    // console.log(heightdiff);

                    
                    // var windowWidth = $(window).width();
                    if (windowWidth > 909) {
                        $('.pop-up-cookies').animate({
                            height: "+=" + height,
                            "margin-top": heightdiff//increases height or decreases depending on values
                        });
                    }

                    $('.agree-button').animate({
                        top: "+=" + height //moves up
                    });

                    // if (windowWidth < 910) {
                        $('.eu-cookie-compliance-save-preferences-button').animate({
                            top: "+=" + height //moves up
                        });
                    // }

        
                    
                }
            }
        });

        $(".eu-cookie-compliance-category label").on('click', function () {
            $(this).toggleClass("toggle-off");
            $(this).parent().toggleClass("category-disabled");
        });

      

        $(".background-cover").on('click', function () {
            $(".eu-cookie-compliance-save-preferences-button").removeClass("cookies-active");
            $(".pop-up-cookies").removeClass("cookies-active");
            $("#eu-cookie-compliance-categories").removeClass("cookies-active");
            $(".eu-cookie-compliance-category").removeClass("cookies-active");
            $(".background-cover").removeClass("cookies-active");
            $("body").removeClass("body-lock");
            $(".eu-cookie-compliance-buttons").removeClass("cookies-active");
            $(".eu-cookie-compliance-categories-buttons").removeClass("cookies-active");
            // var windowWidth = $(window).width();
            if (windowWidth > 909) {
                $('.agree-button').animate({
                    top: 75
                }, 0);
            }
        });

        $(".cookies-reject-button").on('click', function () {
            $('.eu-cookie-compliance-category input').slice(1).prop("checked", false);
            $('.eu-cookie-compliance-save-preferences-button').click();
        })

        //END OF COOKIES

        if (window.location.href.indexOf("/recursos") > -1) {
            $(".category-descriptions .description:first-child").toggleClass("show");
        }

        $(".user-logged-in #site-header #block-menudeutilizador .menu-item a").text("Sair");

        $(".path-forum .action-links a").text("Novo tópico");

        //$('#edit-search-api-fulltext--2').attr("placeholder", "O que procura?");

        $('#block-formulariodepesquisa #search-block-form #edit-keys').attr("placeholder", "O que procura?");

        $('.search-button').on('click', function () {
            $('#block-searchbutton').toggleClass('search-open');
            $('#block-formulariodepesquisa').toggleClass('active');
            $('#content').toggleClass('content-resources-active');
            $('body').toggleClass('body-lock');
        });

        $('#block-filterbutton').on('click', function () {
            $('#block-filterbutton').toggleClass('filter-open');
            $('.block-facets').toggleClass('visible');
            $('#content').toggleClass('content-resources-active');
        });

        $('#block-hambmenubutton').on('click', function () {
            $("#block-hambmenubutton .hamb-button .hamb").toggleClass("pressed-hamb");
            $("#block-navegacaoprincipal").toggleClass("menu-open");
            $('body').toggleClass('body-lock');
        });

        $('.block-facets h2').on('click', function () {
            $(this).toggleClass('active');
            $(this).parent().find('.facets-widget-links').toggleClass('visible');
        });

        $('.block-facets h2').on('click', function () {
            $(this).toggleClass('active');
            $(this).parent().find('.facets-widget-links').toggleClass('visible');
        });

        $('.block-facets h2').on('click', function () {
            $(this).toggleClass('active');
            $(this).parent().find('.facets-widget-links').toggleClass('visible');
        });

        $('.block-facets a').on('click', function () {
            i = 0;
        });

        var b = $('.block-facet--links').find("a.is-active");
        // console.log(b);
        if (b.length !== 0) {
            if (b.parent().parent().parent().parent().children('h2').hasClass('active') == false) {
                b.parent().parent().parent().parent().children('h2').addClass('active');
                b.parent().parent().parent().addClass('visible');
            }
        }

    });


    var query;

    $('#sidebar .form-item-search-api-fulltext #edit-search-api-fulltext--2').submit(function (event) {
        query = $(this).val();
        alert(query);
    });
    $(document).ajaxComplete(function (event, xhr, settings) {
        i = i + 1;

        if (i == 2) {
            i = 0;
            $('body').html($('body').html())
        }
    });
}(jQuery));